import { mutate } from 'swr';

const ACCOUNTING_SEGMENTS = ['account', 'ledger', 'journal', 'mandant', 'reports', 'setup', 'issuer', 'setting', 'product'];

const keyUrl = (key: unknown): string | null => {
    if (typeof key === 'string') return key;
    if (Array.isArray(key) && typeof key[0] === 'string') return key[0];

    return null;
};

/**
 * Revalidates every cached accounting read of the club. Setup, imports and bookings change
 * accounts, balances and the journal at once, and each list is cached under its own URL.
 * Only revalidates, so open screens keep their data until the fresh answer arrives.
 */
export const revalidateAccounting = (clubSlug: string) => {
    const prefixes = ACCOUNTING_SEGMENTS.map((segment) => `invoice/${clubSlug}/${segment}`);

    return mutate((key) => {
        const url = keyUrl(key);

        return (
            !!url &&
            prefixes.some((prefix) => url === prefix || url.startsWith(`${prefix}/`) || url.startsWith(`${prefix}?`))
        );
    });
};

export default revalidateAccounting;
